import React, { useState, useEffect } from 'react';
import Heading from '../utils/Heading';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import mfaApi from '../api/mfaApi';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper';
import ReactLoading from 'react-loading';
import swal from 'sweetalert';

// Helper function to chunk an array into smaller arrays of a specified size
const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const Testimonials = () => {
  const [resdata1, setResdata1] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [resdata, setResdata] = useState([]);
  const getServicesDetails = async () => {
    try {
      const response = await mfaApi.get(`/urbanadmin/getfeedback`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setResdata(response.data.data);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  useEffect(() => {
    getServicesDetails();
    getServicesDetails1();
  }, []);

  // Chunk data into groups of 3
  const chunkedData = chunkArray(resdata, 3);

  // Helper function to truncate text
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  // Toggle expansion state
  const toggleExpand = id => {
    setExpanded(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  //ff
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [rating, setRating] = useState('');
  const [feedbacktext, setFeedbacktext] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async e => {
    e.preventDefault();
    // Call the function without e.preventDefault()
    await addNotification();
  };

  const getServicesDetails1 = async () => {
    try {
      const response = await mfaApi.get(`/urbanadmin/getservicepublic`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setResdata1(response.data.data);
        // setTotal(response.data);
      } else {
        swal(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const [selectedService, setSelectedService] = useState('');
  console.log(selectedService);

  // Handler function to manage the dropdown change
  const handleChange = event => {
    const selectedValue = event.target.value;
    setSelectedService(selectedValue);
  };
  function reloadPageWithDelay() {
    setTimeout(function () {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }, 2000); // 2000 milliseconds (2 seconds)
  }
  const addNotification = async () => {
    if (name === '' || address === '' || rating === '' || feedbacktext === '') {
      swal('Please enter all fields (non-empty values).');
    } else {
      setIsLoading(true);
      try {
        const response = await mfaApi.post(
          `/urbanadmin/createfeedback`,
          {
            name: name,
            rating: rating,
            address: address,
            feedback: feedbacktext,
            servicetype: selectedService,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        if (response.status === 201) {
          swal(response.data.message);
          reloadPageWithDelay();
        }
      } catch (error) {
        swal(error.response?.data?.message || 'An error occurred.');
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="bg-gray-50">
        <Heading
          title="Testimonials - New Urban Services"
          description="New Urban Services is one of the most trusted service providers in India. We provide excellent services for several home appliance care, home care, fitness care"
        />
        <div className="flex justify-center font-extrabold text-2xl text-black">
          <h1>Feedback</h1>
          <button className="absolute mt-9 mb-10 text-sm md:text-md text-red-800 font-normal underline">
            20+ booking Per Day
          </button>
        </div>
        <div
          className={`flex justify-center relative mb-10 ${
            resdata.length === 0 ? 'mt-10' : ''
          }`}
        >
          {/* <a
            href="feedback"
            className="bg-green-600  rounded-md p-1 px-2 absolute mt-14 text-sm md:text-md text-white font-normal "
          >
            + Add your Feedback
          </a> */}
          <div className="flex w-full mt-10  shadow-2xl shadow-gray-100">
            <form
              className=" w-full mx-auto  p-2 rounded-2xl"
              onSubmit={handleSubmit}
            >
              <div className="lg:grid md:grid-cols-6 grid gap-2  md:ml-20">
                <div>
                  <label className="text-gray-800 text-xs block mb-2">
                    Full Name
                  </label>
                  <div className="relative flex items-center">
                    <input
                      name="name"
                      type="text"
                      required
                      value={name}
                      onChange={e => setName(e.target.value)}
                      className="w-full bg-transparent text-sm text-gray-800 border-b border-gray-300 focus:border-blue-500 px-2 py-3 outline-none"
                      placeholder="Enter name"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-gray-800 text-xs block mb-2">
                    Area
                  </label>
                  <div className="relative flex items-center">
                    <input
                      name="address"
                      required
                      value={address}
                      onChange={e => setAddress(e.target.value)}
                      className="w-full bg-transparent text-sm text-gray-800 border-b border-gray-300 focus:border-blue-500 px-2 py-3 outline-none"
                      placeholder="Enter your Area name"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-gray-800 text-xs block mb-2 px-10">
                    Rating (1 to 5)
                  </label>
                  <div className="flex">
                    {[1, 2, 3, 4, 5].map(value => (
                      <div key={value} className="flex items-center px-3">
                        <input
                          id={`rating-${value}`}
                          name="rating"
                          type="radio"
                          value={value}
                          checked={rating === value.toString()}
                          onChange={() => setRating(value.toString())}
                          className="hidden" // Hide the radio buttons
                        />
                        <span
                          onClick={() => setRating(value.toString())}
                          className={`cursor-pointer text-2xl ${
                            value <= rating
                              ? 'text-yellow-500'
                              : 'text-gray-300'
                          }`}
                        >
                          &#9733; {/* Star icon */}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-gray-800 text-xs block mb-2">
                    Service Type
                  </label>
                  <div className="relative flex items-center">
                    <select
                      name="serviceType"
                      required
                      className="w-full bg-transparent text-sm text-gray-800 border-b border-gray-300 focus:border-blue-500 px-2 py-3 outline-none"
                      defaultValue=""
                      onChange={handleChange} // Attach handler
                    >
                      <option value="" disabled hidden>
                        Select service type
                      </option>
                      {resdata1.map(service => (
                        <option key={service.id} value={service.servicename}>
                          {service.servicename}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label className="text-gray-800 text-xs block mb-2">
                    Feedback
                  </label>
                  <div className="relative flex items-center">
                    <textarea
                      name="feedbacktext"
                      required
                      value={feedbacktext}
                      onChange={e => setFeedbacktext(e.target.value)}
                      className="w-full bg-transparent text-sm text-gray-800 border-b border-gray-300 focus:border-blue-500 px-2 py-3 outline-none"
                      placeholder="Enter your feedback"
                    />
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <div className="mt-2">
                    <button
                      type="submit"
                      className="w-1/8 flex justify-center shadow-xl py-2.5 px-5 text-sm font-semibold tracking-wider rounded-md text-white bg-green-600 hover:bg-blue-700 focus:outline-none transition-all"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              {isLoading && (
                <div className="flex items-center justify-center my-5">
                  <ReactLoading
                    type="bubbles"
                    color="#0143E2"
                    height={'4%'}
                    width={'4%'}
                  />
                  Loading...
                </div>
              )}
            </form>
          </div>
        </div>
        <Swiper
          spaceBetween={50}
          centeredSlides={true}
          autoplay={{
            delay: 5000, // 5 seconds delay
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Autoplay]}
        >
          {chunkedData.map((chunk, chunkIndex) => (
            <SwiperSlide key={chunkIndex}>
              <div className="lg:grid md:grid-cols-3 grid-cols-1 gap-6 md:px-24 my-1">
                {chunk.map(data => {
                  const maxLength = 100;
                  const truncatedFeedback = truncateText(
                    data.feedback,
                    maxLength,
                  );
                  const isExpanded = expanded[data.id] || false;

                  return (
                    <div
                      key={data.id}
                      className={`w-full rounded-lg bg-gradient-to-r from-cyan-50 via-red-50 to-blue-50 shadow-lg border-2 px-4`}
                    >
                      <div className="relative flex w-full max-w-[26rem] flex-col rounded-xl bg-transparent bg-clip-border text-gray-700 shadow-none">
                        <div className="relative mx-0 mt-2 flex items-center gap-4 overflow-hidden rounded-xl bg-transparent bg-clip-border pt-0 pb-2 text-gray-700 shadow-none">
                          <div className="flex w-full flex-col gap-0.5">
                            <div className="flex items-center justify-between">
                              <h5 className="block font-sans text-xl font-semibold leading-snug tracking-normal text-black antialiased">
                                {data.name}
                              </h5>
                              <div className="flex items-center gap-0">
                                {[...Array(5)].map((_, index) => (
                                  <svg
                                    key={index}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    aria-hidden="true"
                                    className={`h-5 w-5 ${
                                      index < data.rating
                                        ? 'text-yellow-600'
                                        : 'text-gray-400'
                                    }`}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                                      clipRule="evenodd"
                                    ></path>
                                  </svg>
                                ))}
                              </div>
                            </div>
                            <div className="flex justify-between">
                              <p className="block font-sans text-base font-light leading-relaxed text-blue-gray-900 antialiased">
                                {data.address}
                              </p>
                              <p className="block font-sans text-base font-light leading-relaxed text-blue-gray-900 antialiased">
                                {data.servicetype}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-6 p-0">
                          <p className="block font-sans text-base font-light leading-relaxed text-inherit antialiased">
                            {isExpanded ? data.feedback : truncatedFeedback}
                          </p>
                          {data.feedback.length > maxLength && (
                            <button
                              onClick={() => toggleExpand(data.id)}
                              className=" mt-2 text-red-900 underline text-xs"
                            >
                              {isExpanded ? 'Show Less' : 'Show More'}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default Testimonials;
